<template>
  <MainTabEvents :main-title="mainTitle">
    <ContentWrapper :class="contentWrapperExtraClasses">
      <template #default>
        <Loader v-if="!ordersLoaded"></Loader>
        <template v-else-if="ordersFiltered.length">
          <template v-for="order in ordersFiltered">
            <OrderCard v-if="order.state !== 'expired'" :key="order.id" :order="order"></OrderCard>
          </template>
        </template>
        <template v-else>
          <div class="dea-heading--medium__ml">
            Nessun corso acquistato
          </div>
        </template>
      </template>
    </ContentWrapper>
  </MainTabEvents>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/elements/Loader";
import OrderCard from "@/components/patterns/OrderCard"; // eslint-disable-line import/no-extraneous-dependencies
import MainTabEvents from "~/components/events/components/MainTabEvents";
import ContentWrapper from "~/components/events/components/ContentWrapper";

export default {
  name: "EventsOrders",
  components: {
    ContentWrapper,
    Loader,
    MainTabEvents,
    OrderCard,
  },
  data() {
    return {
      ticketWrapperComponent: "",
      versionIndex: 0,
      preRegistrationFilter: null,
    };
  },
  computed: {
    ...mapGetters(["ticketFilter", "titles", "orders", "ordersLoaded"]),
    mainTitle() {
      return this.titles.main[this.ticketFilter];
    },
    contentWrapperExtraClasses() {
      if (this.ticketFilter === "ordersRecap") {
        return "content-wrapper--reduced-margin";
      }
      return "";
    },
    ordersFiltered() {
      // TODO: this.orders is initially an object and becomes an array after fetchOrders in order.js
      return Array.isArray(this.orders) ? this.orders.filter(order => !order.free) : [];
    },
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    ...mapActions(["fetchOrders"]),
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.subscription-container {
  &__paragraph {
    margin-bottom: $space-base;
    margin-top: $space-x-large;
  }
}
</style>
